import React, { useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';

import { POPUPS } from '@common/constants/popups';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { useBalance } from '@app/dev/terminal/hooks/balance';
import { getAvailableDepositMethods } from '@app/dev/helpers/depositMethods';

const DepositButton = () => {
  const t = useTranslation();
  const terminalBalance = useBalance();
  const user = useSelector((state) => state.user);
  const terminalDepositMode = useSelector((state) => state.terminal.depositMode);

  const availableMethods = useMemo(
    () => getAvailableDepositMethods(user, terminalBalance, terminalDepositMode),
    [user, terminalBalance, terminalDepositMode],
  );

  const [{ openPopup }] = useContext(PopupContext);

  if (!availableMethods.length) return null;

  const [firstMethod] = availableMethods;

  if (availableMethods.length === 1) {
    return (
      <button
        key={firstMethod.type}
        type="button"
        className={`deposit-method-button deposit-${firstMethod.type}-bg`}
        onClick={() => openPopup(POPUPS.DEPOSIT, { type: firstMethod.type })}
      >
        <img src={firstMethod.logo} width={24} height={24} alt="deposit logo" />
        {firstMethod.name}
      </button>
    );
  }

  return (
    <button className="deposit-button" onClick={() => openPopup(POPUPS.CHOOSE_DEPOSIT_METHOD)}>
      {t('Deposit')}
    </button>
  );
};

export default DepositButton;
